"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryInfoView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const InfoWrap = (0, app_1.styled)(app_1.Link) `
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Category = (0, app_1.styled)(app_1.Text) `
  margin-bottom: ${(theme) => theme.spacing.medium};
  font-size: 1.5rem;
`;
function CategoryInfoView({ category, description, slug, }) {
    const categoryPath = (0, app_1.useContextPath)('ecommerce.category');
    const realPath = slug ? `${categoryPath}/${slug}` : undefined;
    return ((0, jsx_runtime_1.jsxs)(InfoWrap, Object.assign({ href: realPath }, { children: [(0, jsx_runtime_1.jsx)(Category, Object.assign({ tag: "h2" }, { children: category })), (0, jsx_runtime_1.jsx)(app_1.Text, { children: description })] })));
}
exports.CategoryInfoView = CategoryInfoView;
